import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoRiskTemplates = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 226,
	height: 176,
	viewBox: "0 0 226 176",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_17363",
				"data-name": "Rectangle 17363",
				width: 226,
				height: 176,
				transform: "translate(810 757)",
				fill: "#fff",
				stroke: "#707070",
				strokeWidth: 1
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-2",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15208",
				"data-name": "Path 15208",
				d: "M2466.338,623.822a.794.794,0,0,0,.759.8.746.746,0,0,0,.758-.76.794.794,0,0,0-.758-.8h-.02a.746.746,0,0,0-.739.761",
				transform: "translate(-2466.338 -623.061)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "no-risk-templates-linear-gradient",
			x1: -70.177,
			y1: 66.213,
			x2: -70.149,
			y2: 66.213,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#ff9085"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#fb6fbb"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-3",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15209",
				"data-name": "Path 15209",
				d: "M2519.216,625.229a.79.79,0,0,0,.754.8.742.742,0,0,0,.753-.758.79.79,0,0,0-.753-.8h-.02a.743.743,0,0,0-.734.758",
				transform: "translate(-2519.216 -624.471)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "no-risk-templates-linear-gradient-2",
			x1: -71.954,
			y1: 66.486,
			x2: -71.925,
			y2: 66.486,
			xlinkHref: "#no-risk-templates-linear-gradient"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-4",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15210",
				"data-name": "Path 15210",
				d: "M2571.8,626.628a.787.787,0,0,0,.75.8.739.739,0,0,0,.749-.756.787.787,0,0,0-.749-.8h-.02a.74.74,0,0,0-.73.756",
				transform: "translate(-2571.795 -625.872)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "no-risk-templates-linear-gradient-3",
			x1: -73.732,
			y1: 66.76,
			x2: -73.704,
			y2: 66.76,
			xlinkHref: "#no-risk-templates-linear-gradient"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-5",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15223",
				"data-name": "Path 15223",
				d: "M1637.6,892.763v-1.658a2.711,2.711,0,0,0-1.688-2.525,9.224,9.224,0,0,1-5.827-9.631,9.45,9.45,0,0,1,8.523-8.141,10.429,10.429,0,0,1,1.117-.049,9.7,9.7,0,0,1,6.354,2.412,9.109,9.109,0,0,1-2.6,15.365,2.741,2.741,0,0,0-1.67,2.535v1.651a1.331,1.331,0,0,1-1.334,1.3l-1.537.017h-.015a1.3,1.3,0,0,1-1.326-1.28m.963-22.341a9.846,9.846,0,0,0-8.884,8.482,9.607,9.607,0,0,0,6.073,10.034,2.326,2.326,0,0,1,1.445,2.17v1.659a1.694,1.694,0,0,0,1.743,1.664l1.537-.017a1.73,1.73,0,0,0,1.734-1.695v-1.651a2.352,2.352,0,0,1,1.427-2.178,9.49,9.49,0,0,0,2.7-16,10.105,10.105,0,0,0-6.724-2.515q-.524,0-1.056.052",
				transform: "translate(-1629.619 -870.371)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "no-risk-templates-linear-gradient-4",
			x1: -2.852,
			y1: 3.987,
			x2: -2.85,
			y2: 3.987,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#e38ddd"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .004,
					stopColor: "#e38ddd"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#9571f6"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-6",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15224",
				"data-name": "Path 15224",
				d: "M1761.508,1299.467v.575a.1.1,0,0,0,.1.1.1.1,0,0,0,.1-.1v-.38l4.232-.053v.531l-4.433.76v.474l4.433-.062v.6l-3.516.051a.1.1,0,0,0-.1.1.1.1,0,0,0,.1.1l3.716-.054v-.989l-4.431.061v-.115l4.431-.761v-.888Z",
				transform: "translate(-1761.508 -1299.41)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "no-risk-templates-linear-gradient-5",
			x1: -20.485,
			y1: 18.094,
			x2: -20.473,
			y2: 18.094,
			xlinkHref: "#no-risk-templates-linear-gradient-4"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-7",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15225",
				"data-name": "Path 15225",
				d: "M1771.818,1355.237a.1.1,0,0,0-.1.1,1.736,1.736,0,0,1-1.729,1.7,1.674,1.674,0,0,1-1.734-1.646.1.1,0,0,0-.1-.1.1.1,0,0,0-.1.1,1.867,1.867,0,0,0,1.935,1.837,1.938,1.938,0,0,0,1.929-1.9.1.1,0,0,0-.1-.1h0",
				transform: "translate(-1768.054 -1355.237)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "no-risk-templates-linear-gradient-6",
			x1: -26.036,
			y1: 21.794,
			x2: -26.021,
			y2: 21.794,
			xlinkHref: "#no-risk-templates-linear-gradient-4"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-8",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15226",
				"data-name": "Path 15226",
				d: "M1771.922,1080.069l-1.928,9.662-1.741-9.657a.1.1,0,0,0-.116-.079.1.1,0,0,0-.082.112l1.835,10.178a.1.1,0,0,0,.1.079h0a.1.1,0,0,0,.1-.079l2.031-10.18a.1.1,0,0,0-.079-.113l-.019,0a.1.1,0,0,0-.1.078",
				transform: "translate(-1768.053 -1079.99)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "no-risk-templates-linear-gradient-7",
			x1: -9.505,
			y1: 11.069,
			x2: -9.499,
			y2: 11.069,
			xlinkHref: "#no-risk-templates-linear-gradient-4"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-9",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15251",
				"data-name": "Path 15251",
				d: "M1991.856,1165.092l-2.743,11.3a8.032,8.032,0,0,0,1.156,6.4l7.924,11.7a2.868,2.868,0,0,0,4.965-.377c10.165-21.53-1.753-34.931-1.753-34.931Z",
				transform: "translate(-1988.886 -1159.182)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "no-risk-templates-linear-gradient-8",
			x1: -2.407,
			y1: 2.496,
			x2: -2.406,
			y2: 2.496,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#444b8c"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .996,
					stopColor: "#26264f"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#26264f"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-10",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15252",
				"data-name": "Path 15252",
				d: "M1148.67,768.455a2.868,2.868,0,0,0,.768,4.92l13.2,5.041a8.033,8.033,0,0,0,6.5-.338l10.374-5.254,3.571-10.648a26.277,26.277,0,0,0-11.583-2.448c-6.127,0-14.165,1.842-22.824,8.726",
				transform: "translate(-1147.591 -759.729)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "no-risk-templates-linear-gradient-9",
			x1: -1.755,
			y1: 3.397,
			x2: -1.753,
			y2: 3.397,
			xlinkHref: "#no-risk-templates-linear-gradient-8"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-11",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15253",
				"data-name": "Path 15253",
				d: "M2011.837,1139.875l-2.743,11.3a8.032,8.032,0,0,0,1.156,6.4l7.925,11.7a2.868,2.868,0,0,0,4.965-.377c10.165-21.53-1.753-34.931-1.753-34.931Z",
				transform: "translate(-2008.868 -1133.965)",
				fill: "#a9cef7"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-12",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15254",
				"data-name": "Path 15254",
				d: "M1168.651,743.239a2.867,2.867,0,0,0,.768,4.92l13.2,5.041a8.033,8.033,0,0,0,6.5-.338l10.374-5.254,3.571-10.648a26.278,26.278,0,0,0-11.583-2.448c-6.127,0-14.165,1.842-22.824,8.727",
				transform: "translate(-1167.572 -734.512)",
				fill: "#a9cef7"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-13",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15255",
				"data-name": "Path 15255",
				d: "M1602.978,14.695c-15.2,15.347-22.31,43.222-23.541,48.464-.13.554-.3,1.452.242,1.63a43.763,43.763,0,0,1,23.989,19c.313.5,1.166.139,1.691-.122,4.887-2.431,30.329-15.706,41.773-33.983,12.617-20.15.34-45.733.3-45.74a58.421,58.421,0,0,0-11.834-1.1c-9.543,0-22.928,2.066-32.625,11.854",
				transform: "translate(-1579.306 -2.841)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-14",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15257",
				"data-name": "Path 15257",
				d: "M2183.443,6.706c7.1,1.453,15.032,6.076,21.475,11.182s13.254,12.469,15.794,18.35c2.47-14.351-2.914-28.125-4.39-31.5a1.641,1.641,0,0,0-1.207-.957,63.084,63.084,0,0,0-10.986-.929,53.536,53.536,0,0,0-20.686,3.856",
				transform: "translate(-2183.443 -2.85)",
				fill: "#a9cef7"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-15",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15259",
				"data-name": "Path 15259",
				d: "M1966.592,300.869c-5.922,7.473-3.995,18.861,4.3,25.437s19.825,5.847,25.747-1.626,4-18.861-4.3-25.437a20.356,20.356,0,0,0-12.59-4.492,16.545,16.545,0,0,0-13.157,6.118",
				transform: "translate(-1963.157 -294.751)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "no-risk-templates-linear-gradient-10",
			x1: -1.9,
			y1: 2.893,
			x2: -1.899,
			y2: 2.893,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#ebeff2"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .004,
					stopColor: "#ebeff2"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#fff"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-16",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15261",
				"data-name": "Path 15261",
				d: "M1992.415,325.852c-5.428,6.85-3.662,17.289,3.944,23.316s18.172,5.36,23.6-1.49,3.662-17.289-3.944-23.316a18.659,18.659,0,0,0-11.54-4.118,15.166,15.166,0,0,0-12.06,5.608",
				transform: "translate(-1989.267 -320.244)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "no-risk-templates-linear-gradient-11",
			x1: -2.664,
			y1: 3.505,
			x2: -2.662,
			y2: 3.505,
			xlinkHref: "#no-risk-templates-linear-gradient-10"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-17",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15262",
				"data-name": "Path 15262",
				d: "M2029.008,361.252c-4.728,5.967-3.19,15.06,3.436,20.31s15.83,4.669,20.558-1.3,3.19-15.06-3.436-20.31a16.255,16.255,0,0,0-10.053-3.587,13.211,13.211,0,0,0-10.505,4.885",
				transform: "translate(-2026.265 -356.367)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "no-risk-templates-linear-gradient-12",
			x1: -3.605,
			y1: 4.318,
			x2: -3.603,
			y2: 4.318,
			xlinkHref: "#no-risk-templates-linear-gradient-8"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-18",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15263",
				"data-name": "Path 15263",
				d: "M1570.525,1036.439c-1.616,2.039,2.669,8.125,9.57,13.594s13.806,8.249,15.421,6.21-2.669-8.125-9.57-13.594c-5.366-4.251-10.733-6.878-13.616-6.878a2.192,2.192,0,0,0-1.806.669",
				transform: "translate(-1570.184 -1035.77)",
				fill: "#a9cef7"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-19",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15264",
				"data-name": "Path 15264",
				d: "M1536.122,1117.4l-3.006,1.7a1.792,1.792,0,0,0-.23,2.964l17.785,14.093a1.792,1.792,0,0,0,2.833-.9l.97-3.315a8.942,8.942,0,0,0-3.029-9.521l-5.363-4.25a8.943,8.943,0,0,0-9.961-.772",
				transform: "translate(-1532.207 -1116.242)",
				fill: "#7284fa"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-20",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15265",
				"data-name": "Path 15265",
				d: "M1523.328,1172.482c-1.525,1.924,1.856,7.142,7.552,11.655s11.549,6.612,13.073,4.688-1.856-7.142-7.552-11.655c-4.261-3.377-8.611-5.4-11.17-5.4a2.313,2.313,0,0,0-1.9.714",
				transform: "translate(-1522.962 -1171.768)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "no-risk-templates-linear-gradient-13",
			x1: -3.373,
			y1: 3.74,
			x2: -3.371,
			y2: 3.74,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#aa80f9"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .996,
					stopColor: "#6165d7"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6165d7"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-21",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15266",
				"data-name": "Path 15266",
				d: "M1566.715,1208.487c-1.159,1.462,1.411,5.428,5.739,8.858s8.777,5.025,9.935,3.563-1.411-5.428-5.739-8.858c-3.238-2.566-6.544-4.105-8.489-4.105a1.758,1.758,0,0,0-1.447.543",
				transform: "translate(-1566.437 -1207.944)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "no-risk-templates-linear-gradient-14",
			x1: -4.596,
			y1: 4.769,
			x2: -4.593,
			y2: 4.769,
			xlinkHref: "#no-risk-templates-linear-gradient-8"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "no-risk-templates-clip-path-22",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15268",
				"data-name": "Path 15268",
				d: "M339.129,1231.084c-4.1,1.264-7.284.414-10.339-.436-3-.834-5.879-1.668-9.4-.5-8.961,2.967-6.794,13.849-15.663,18.17-5.286,2.575-10.515.882-15.383-.812-4.7-1.634-9.058-3.267-12.812-1.068-3.832,2.245-15.221,12.769,18.421,27.74h0c35.082,14.307,46.949-4.034,48.691-6.689,4.435-6.759-2.376-14.5,1.808-20.738,2.848-4.244,7.277-2.553,11.318-7.579,3.02-3.756,3.51-8.385,3.474-11.626,0,0-4.091-6.217-8.6-6.45-2.067,3.425-5.714,8.2-11.519,9.991",
				transform: "translate(-269.752 -1221.093)",
				fill: "none"
			})
		})
	] }), /* @__PURE__ */ _jsx("g", {
		id: "Mask_Group_14588",
		"data-name": "Mask Group 14588",
		transform: "translate(-810 -757)",
		clipPath: "url(#no-risk-templates-clip-path)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_15102",
			"data-name": "Group 15102",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Path_39780",
				"data-name": "Path 39780",
				d: "M89.438.037C117.924.8,146.785,13.191,154.3,42.117c3.7,14.224-1.156,29.314,3.473,43.349,4.681,14.192,19.534,18.341,29.71,27.839,12.286,11.469,15.957,31.353,7.76,46.075-8.846,15.888-30.233,23.825-47.618,17.671-15-5.311-25.159-18.859-38.445-27.505a65.85,65.85,0,0,0-39.3-10.415c-7.961.452-15.847,2.352-23.81,1.961C24.035,140.01,6.06,120.708,1.493,99.577S3.386,56.363,13.407,37.121c3.849-7.391,8.339-14.652,14.755-20.073C37.542,9.121,50.03,5.909,62.044,2.932A103.563,103.563,0,0,1,89.438.037Z",
				transform: "matrix(0.643, -0.766, 0.766, 0.643, 782.279, 858.93)",
				fill: "#7b8efa",
				opacity: .137
			}), /* @__PURE__ */ _jsx("g", {
				id: "Group_12289",
				"data-name": "Group 12289",
				transform: "translate(37.939 -26.417)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_12275",
					"data-name": "Group 12275",
					transform: "translate(7.496 602.469)",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group_12059",
						"data-name": "Group 12059",
						transform: "translate(777.952 186.142)",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "Group_12288",
							"data-name": "Group 12288",
							children: [
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11854",
									"data-name": "Group 11854",
									transform: "translate(145.389 36.729)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11853",
										"data-name": "Group 11853",
										clipPath: "url(#no-risk-templates-clip-path-2)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14499",
											"data-name": "Rectangle 14499",
											width: 2.068,
											height: 2.042,
											transform: "translate(-0.607 1.284) rotate(-64.722)",
											fill: "url(#no-risk-templates-linear-gradient)"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11856",
									"data-name": "Group 11856",
									transform: "translate(148.506 36.812)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11855",
										"data-name": "Group 11855",
										clipPath: "url(#no-risk-templates-clip-path-3)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14500",
											"data-name": "Rectangle 14500",
											width: 2.06,
											height: 2.032,
											transform: "translate(-0.605 1.281) rotate(-64.722)",
											fill: "url(#no-risk-templates-linear-gradient-2)"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11858",
									"data-name": "Group 11858",
									transform: "translate(151.605 36.895)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11857",
										"data-name": "Group 11857",
										clipPath: "url(#no-risk-templates-clip-path-4)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14501",
											"data-name": "Rectangle 14501",
											width: 2.052,
											height: 2.022,
											transform: "translate(-0.603 1.277) rotate(-64.722)",
											fill: "url(#no-risk-templates-linear-gradient-3)"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11895",
									"data-name": "Group 11895",
									transform: "translate(96.065 51.308)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11894",
										"data-name": "Group 11894",
										clipPath: "url(#no-risk-templates-clip-path-5)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14518",
											"data-name": "Rectangle 14518",
											width: 31.582,
											height: 31.07,
											transform: "translate(-12.232 14.434) rotate(-50.748)",
											fill: "url(#no-risk-templates-linear-gradient-4)"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11897",
									"data-name": "Group 11897",
									transform: "translate(103.84 76.599)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11896",
										"data-name": "Group 11896",
										clipPath: "url(#no-risk-templates-clip-path-6)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14519",
											"data-name": "Rectangle 14519",
											width: 5.059,
											height: 5.326,
											transform: "translate(-1.346 1.647) rotate(-50.748)",
											fill: "url(#no-risk-templates-linear-gradient-5)"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11899",
									"data-name": "Group 11899",
									transform: "translate(104.225 79.89)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11898",
										"data-name": "Group 11898",
										clipPath: "url(#no-risk-templates-clip-path-7)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14520",
											"data-name": "Rectangle 14520",
											width: 4.001,
											height: 4.263,
											transform: "matrix(0.633, -0.774, 0.774, 0.633, -0.984, 1.205)",
											fill: "url(#no-risk-templates-linear-gradient-6)"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11901",
									"data-name": "Group 11901",
									transform: "translate(104.225 63.665)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11900",
										"data-name": "Group 11900",
										clipPath: "url(#no-risk-templates-clip-path-8)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14521",
											"data-name": "Rectangle 14521",
											width: 10.621,
											height: 9.729,
											transform: "translate(-5.093 6.219) rotate(-50.748)",
											fill: "url(#no-risk-templates-linear-gradient-7)"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11943",
									"data-name": "Group 11943",
									transform: "translate(117.243 68.333)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11942",
										"data-name": "Group 11942",
										clipPath: "url(#no-risk-templates-clip-path-9)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14533",
											"data-name": "Rectangle 14533",
											width: 44.48,
											height: 42.462,
											transform: "translate(-18.387 22.819) rotate(-51.61)",
											fill: "url(#no-risk-templates-linear-gradient-8)"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11945",
									"data-name": "Group 11945",
									transform: "translate(67.65 44.785)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11944",
										"data-name": "Group 11944",
										clipPath: "url(#no-risk-templates-clip-path-10)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14534",
											"data-name": "Rectangle 14534",
											width: 37.726,
											height: 40.436,
											transform: "translate(-10.147 11.977) rotate(-51.61)",
											fill: "url(#no-risk-templates-linear-gradient-9)"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11947",
									"data-name": "Group 11947",
									transform: "translate(118.421 66.846)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11946",
										"data-name": "Group 11946",
										clipPath: "url(#no-risk-templates-clip-path-11)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14535",
											"data-name": "Rectangle 14535",
											width: 44.401,
											height: 39.23,
											transform: "translate(-15.649 29.039) rotate(-62.152)",
											fill: "#a9cef7"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11949",
									"data-name": "Group 11949",
									transform: "translate(68.828 43.299)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11948",
										"data-name": "Group 11948",
										clipPath: "url(#no-risk-templates-clip-path-12)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14536",
											"data-name": "Rectangle 14536",
											width: 34.121,
											height: 41.064,
											transform: "matrix(0.467, -0.884, 0.884, 0.467, -8.709, 15.242)",
											fill: "#a9cef7"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11951",
									"data-name": "Group 11951",
									transform: "translate(93.099 0.167)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11950",
										"data-name": "Group 11950",
										clipPath: "url(#no-risk-templates-clip-path-13)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14537",
											"data-name": "Rectangle 14537",
											width: 87.592,
											height: 88.346,
											transform: "translate(-7.444 0.655) rotate(-5.146)",
											fill: "#bdd3ec"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11960",
									"data-name": "Group 11960",
									transform: "translate(128.712 0.168)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11959",
										"data-name": "Group 11959",
										clipPath: "url(#no-risk-templates-clip-path-14)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14541",
											"data-name": "Rectangle 14541",
											width: 42.422,
											height: 46.943,
											transform: "matrix(0.255, -0.967, 0.967, 0.255, -8.237, 31.214)",
											fill: "#a9cef7"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11969",
									"data-name": "Group 11969",
									transform: "translate(115.727 17.375)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11968",
										"data-name": "Group 11968",
										clipPath: "url(#no-risk-templates-clip-path-15)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14545",
											"data-name": "Rectangle 14545",
											width: 55.902,
											height: 56.515,
											transform: "translate(-21.047 23.425) rotate(-51.61)",
											fill: "url(#no-risk-templates-linear-gradient-10)"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11978",
									"data-name": "Group 11978",
									transform: "translate(117.266 18.878)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11977",
										"data-name": "Group 11977",
										clipPath: "url(#no-risk-templates-clip-path-16)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14549",
											"data-name": "Rectangle 14549",
											width: 42.412,
											height: 45.036,
											transform: "translate(-9.642 33.324) rotate(-77.541)",
											fill: "url(#no-risk-templates-linear-gradient-11)"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11980",
									"data-name": "Group 11980",
									transform: "translate(119.447 21.008)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11979",
										"data-name": "Group 11979",
										clipPath: "url(#no-risk-templates-clip-path-17)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14550",
											"data-name": "Rectangle 14550",
											width: 32.688,
											height: 35.477,
											transform: "translate(-4.088 30.3) rotate(-86.032)",
											fill: "url(#no-risk-templates-linear-gradient-12)"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11982",
									"data-name": "Group 11982",
									transform: "translate(92.561 61.058)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11981",
										"data-name": "Group 11981",
										clipPath: "url(#no-risk-templates-clip-path-18)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14551",
											"data-name": "Rectangle 14551",
											width: 34.446,
											height: 35.986,
											transform: "translate(-11.712 15.469) rotate(-55.992)",
											fill: "#a9cef7"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11984",
									"data-name": "Group 11984",
									transform: "translate(90.322 65.802)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11983",
										"data-name": "Group 11983",
										clipPath: "url(#no-risk-templates-clip-path-19)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14552",
											"data-name": "Rectangle 14552",
											width: 30.893,
											height: 31.364,
											transform: "translate(-10.398 12.723) rotate(-51.61)",
											fill: "#7284fa"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11986",
									"data-name": "Group 11986",
									transform: "translate(89.778 69.075)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11985",
										"data-name": "Group 11985",
										clipPath: "url(#no-risk-templates-clip-path-20)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14553",
											"data-name": "Rectangle 14553",
											width: 25.936,
											height: 28.74,
											transform: "matrix(0.342, -0.94, 0.94, 0.342, -7.261, 16.759)",
											fill: "url(#no-risk-templates-linear-gradient-13)"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11988",
									"data-name": "Group 11988",
									transform: "translate(92.34 71.207)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11987",
										"data-name": "Group 11987",
										clipPath: "url(#no-risk-templates-clip-path-21)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14554",
											"data-name": "Rectangle 14554",
											width: 19.711,
											height: 21.842,
											transform: "matrix(0.342, -0.94, 0.94, 0.342, -5.518, 12.737)",
											fill: "url(#no-risk-templates-linear-gradient-14)"
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_11997",
									"data-name": "Group 11997",
									transform: "translate(15.902 71.983)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_11996",
										"data-name": "Group 11996",
										clipPath: "url(#no-risk-templates-clip-path-22)",
										children: /* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_14558",
											"data-name": "Rectangle 14558",
											width: 86.921,
											height: 105.514,
											transform: "translate(-22.028 45.232) rotate(-65.846)",
											fill: "#cfd5fa"
										})
									})
								})
							]
						})
					})
				})
			})]
		})
	})]
});
export default SvgNoRiskTemplates;
